import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'VOICE_UPDATE',
    smsDelete : 'VOICE_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        
        marathon:[],
        submitLoading: false,
        marathonLoading: false,
        marathonError: false,
        ...store
    },

    mutations : {
        ...mutations,
       
        SET_MARATHON(state, marathon) {
            state.marathon = marathon;
        },
        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        MARATHON_LOADING (state, loading) {
            state.marathonLoading = loading;
        },
        MARATHON_ERROR (state, hasError) {
            state.marathonError = hasError;
        },
        
    },

    actions: {


        async fetchMarathon ({ commit }) {
            commit('MARATHON_LOADING', true);
            commit('MARATHON_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_marathon_list, config);
                let response = result.data

                commit('SET_MARATHON', response.data);

            } catch(error) {
                commit('MARATHON_ERROR', true);
            }
            finally {
                commit('MARATHON_LOADING', false);
            }
        },





       








    },

    getters: {}
}
